module.exports = __webpack_public_path__ + "img/send.d710f77b.svg";